import mudd from "../images/itsme.png";
import proje4 from "../components/assets/img/project/proj-4.webp";
import proje2 from "../components/assets/img/project/proj-2.webp";
import proje3 from "../components/assets/img/project/proj-3.webp";
import proje5 from "../components/assets/img/project/proj-5.webp";
import proje1 from "../components/assets/img/project/proj-1.webp";
import proje6 from "../components/assets/img/project/proj-6.webp";
import proje7 from "../components/assets/img/project/proj-7.webp";
import proje8 from "../components/assets/img/project/proj-8.webp";
import proje0 from "../components/assets/img/project/proj-9.webp";
import innerTwoProject03 from "../components/assets/img/project/inner_two_project03.jpg";
import testimonialAvatar1 from '../components/assets/img/images/testimonial_avatar01.png';
import testimonialAvatar2 from '../components/assets/img/images/testimonial_avatar02.png';
import testimonialAvatar3 from '../components/assets/img/images/testimonial_avatar03.png';
import cellularIMG from "../components/assets/img/project/cellular-optics.webp";
import cellercertifiedIMG from '../components/assets/img/project/celler-certified.webp';
import skuopticsdIMG from '../components/assets/img/project/sku-optics.webp';
import outsetIMG from '../components/assets/img/project/out-set.webp';
import recommercedIMG from '../components/assets/img/project/upcycle-it.webp';
import chronoIMG from '../components/assets/img/project/crown-chrono.webp';
import ASdesignIMG from '../components/assets/img/project/AS-design.webp';
import nexusperformanceIMG from '../components/assets/img/project/nexus-performance.webp';
import SARMSEBOOK5 from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/Ebook5-SARMs-SUPPORT-Template.pdf';
import SARMSEBOOK5IMG from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/SARMs-support-image.png';
import VitaminsPdf from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/Vitamins-Vitality-book2.pdf';
import Vitamins from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/vitamins.png';
import TestosteronePdf from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/Testosterone-Health-Playbook-Guide-L-Evate-book2.pdf'
import Testosterone from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/testosterone.png';
import PeptidePdf from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/Peptide-Playbook-Guide-book1.pdf'
import Peptide from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/peptide.png';
import PeptideEvate from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/peptide-evate.png';
import PeptideEvatePdf from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/Peptide-Playbook-Guide-L-Evate-book1.pdf';
import InvestifagePeptide from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/investigating-peptides.png';
import InvestifagePeptidePdf from '../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/INVESTIGATING-RESEARCH-PEPTIDES-Ebook-3.pdf';
import SARMsUncovered from "../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/SARMs-uncovered.png"
import SARMsUncoveredPdf from "../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/SARMs-Uncovered-Ebook.pdf"
import RecoverySupplements from "../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/recovery-supplements.png"
import RecoverySupplementsPdf from "../components/assets/img/project/Mudd-all-Portfolio/Ebook-Design/Recovery-Supplements-book1.pdf"

// Email Design Imports
import BHNewsletterAprilEmail2 from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-April-Email-2-copy.jpg';
import BHNewsletterEmail1March17 from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Email-1-March-17-copy.jpg';
import BHNewsletterEmail1Valentine from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Email-1-Valentine-Sale-Is-Live-copy.jpg';
import BHNewsletterEmail11BBenefit from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Email-11-B-Benefit-Focused-copy.jpg';
import BHNewsletterEmail12Blend from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Email-12-Blend-Focused-copy.jpg';
import BHNewsletterEmail12BBlend from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Email-12-B-Blend-Focused-copy.jpg';
import BHNewsletterEmail4Stock from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Email-4-Stock-Is-Moving-Fast-copy.jpg';
import BHNewsletterEmail5Compounds from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Email-5-Compounds-Work-Better-Together-copy.jpg';
import BHNewsletterMarchEmail1Educational from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-March-Email-1-Educational-B-copy.jpg';
import BHNewsletterMarchEmail3Blend from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-March-Email-3-Blend-focused-copy.jpg';
import BHNewsletterMarchEmail3BBlend from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-March-Email-3-Blend-focused-B-copy.jpg';
import BHNewsletterWannaSayGoodnight from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Wanna-say-Goodnight-copy.jpg';
import BHNewsletterFebWeek1Email3Blend from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-feb-week1-Email-3-Blend-Focused.jpg';
import BHNewsletterWeek4Email2Benefit from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-week-4-Email-2-Benefit-Focused-copy.jpg';
import BHNewsletterWeek4Email3Blend from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-week4-Email-3-Blend-Focused-copy.jpg';
import BHNewsletterEmail3March19 from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Email-3-March-19-copy.jpg';
import BHNewsletterFreeShaker from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-Free-Shaker-on-Orders-copy.jpg';
import BHNewsletterMarchEmail2BStoryBrand from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-March-Email-2-B-Story-Brand-copy.jpg';
import BHNewsletterWeek2Email4Educational from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/BH-newsletter-week-2-Email-4-Educational-copy.jpg';
import Email2StoryBased from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/EMAIL-2-Story-Based-Email-copy.jpg';
import OrionWelcomeEmail1 from '../components/assets/img/project/Mudd-all-Portfolio/Email-Design/Orion-Welcome-Email-1-copy.jpg';

// Label Design Imports
import HydroxyShotsJPG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/7-Hydroxy-Mitragynine-Shots-50mg-NU.jpg';
import HydroxyShotsPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/7-Hydroxy-Mitragynine-Shots-50mg-NU.pdf';
import HydroxyTabsJPG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/7-Hydroxy-Mitragynine-6oct-50x50-NU.jpg';
import HydroxyTabsPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/7-Hydroxy-Mitragynine-6oct-50x50-NU.pdf';
import HydroxyTabsIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/HydroxyTabsIMG.png';
import AdvancedSupportPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Advanced-Testicular-and-Prostate-Support-Capsules-60oct-IML.pdf';
import AdvancedSupportIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/AdvancedSupportIMG.png';
import B733PDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/B7-33-12mg-Purz.pdf';
import B733IMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/BC33IMG.png';
import BACWaterPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/BAC-Water-30ml-Water-BC9.pdf';
import BACWaterIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/BACWaterIMG.png';
import BromantanePDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Bromantane-100mg-60ml-IML.pdf';
import BromantaneIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/BromantaneIMG.png';
import CBDMelatoninPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/CBD-Melatonin-Gummies-60oct-IML-black.pdf';
import CBDMelatoninIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/CBDMelatoninIMG.png';
import DreamCatcherJPG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Dream-Catcher-30scoops-IML.jpg';
import DreamCatcherPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Dream-Catcher-30scoops-IML.pdf';
import EmideltidePDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Emideltide-2mg-PURZ.pdf';
import EmideltideIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/EmideltideIMG.png';
import EnclomiphenePDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Enclomiphene-Citrate-20mg-54ct-IML.pdf';
import EnclomipheneIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/EnclomipheneIMG.png';
import EpithalonPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Epithalon-1mg-10ml-NU.pdf';
import EpithalonIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/EpithalonIMG.png';
import SmallVialBoxPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Final-Small-Vial-Box-BC9-20X20X44mm.pdf';
import SmallVialBoxIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/SmallvialboxIMG.png';
import PeptideBoxPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Final-peptide-box-150x70x36mm.pdf';
import PeptideBoxIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/PeptideBoxIMG.png';
import GLP1PDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/GLP-1-3-Liraglutide-1mg.pdf';
import GLP1IMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/GLP1IMG.png';
import IGF1LR3PDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/IGF-1-LR3-1mg-Peptide-orion.pdf';
import IGF1LR3IMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/IGF1LR3IMG.png';
import KPVNasalPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/KPV-500mcg-10ml-NU.pdf';
import KPVNasalIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/KPVNasalIMG.png';
import MOTSCNasalJPG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/MOTS-C-200mcg-10ml-NU-2.jpg';
import Melanotan2PDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Melanotan-2-100mcg-10ml-NU.pdf';
import Melanotan2IMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Melanotan2IMG.png';
import OT9AminoPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/OT-9-amino-2mg-Peptide.pdf';
import OT9AminoIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/OT9AminoIMG.png';
import SermorelinPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/SERMORELIN-black-10mg-Peptide-optimo-1-.pdf';
import SermorelinIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/SermorelinIMG.png';
import TB500PDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/TB-500-10mg-Peptide-optimo.pdf';
import TB500IMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/TB500IMG.png';
import AllThreeNewJPG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/all-three-new.jpg';
import CapsulesLabelsPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/capsules-labels.pdf';
import CapsulesLabelsIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/CapsulesLabelsIMG.png';
import FacialCreamPDF from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/facial-cream.pdf';
import FacialCreamIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/facialcream.png';
import Oxytocin1 from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Oxytocin-100mcg-10ml-NU-1.jpg';
import Oxytocin2 from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/Oxytocin-100mcg-10ml-NU-2.jpg';
import VIPPeptide from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/VIP-5mg-Peptide-orion.jpg';
//import CapsulesJPG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/capsules.jpg';

// Social Media Imports
import Insta2JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/insta-2.jpg';
import Mar28Static7JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-28-STATIC-POST-7.jpg';
import Mar9Static2JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-9-STATIC-POST-2.jpg';
import Mar27ProductJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-27-PRODUCT-POST.jpg';
import Mar31Static8JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-31-STATIC-POST-8.jpg';
import Mar3StaticJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-3-STATIC-POST.jpg';
import AprilPost2JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/april-post-2.jpg';
import QuickQuoteJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/quick-quote.jpg';
import Mar31StaticJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-31-STATIC-POST.jpg';
import Volk1JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/volk-1.jpg';
import Feb18Static8JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/FEB-18-STATIC-8.jpg';
import YouAreYourOwnJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/you-areyour-won.jpeg';
import Mar21Static5JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-21-STATIC-POST-5.jpg';
import PurzBrandAwarenessJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/Post-1-Brand-Awareness-Purz.jpg';
import UxUiJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/ux-ui.jpg';
import Mar21ProductJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-21-PRODUCT-POST.jpg';
import Post2JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/post-2.jpg';
import AprilPost1JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/april-post-1.jpg';
import PurzConversionJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/Post-2-Sales-Conversion.jpg';
import Mar14StaticJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/Static-Post-14-March.jpg';
import Mar19FinalCallJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/Final-Call-Static-Post-19-March.jpg';
import Mar17MainDayJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/Main-Day-Static-Post-17-March.jpg';
import Mar19FinalCallStaticJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/19-MARCH-FINAL-CALL-STATIC-POST.jpg';
import Mar4Static1JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-4-STATIC-POST-1.jpg';
import Post3PromeoJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/post-3-promeo.jpg';
import Post2PromeoJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/post-2-promeo.jpg';
import Mar9ProductJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-9-PRODUCT-POST.jpg';
import Post1PromeoJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/post-1-promeo.jpg';
import Post4PromeoJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/post-4-promeo.jpg';
import Mar25Static6JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/MAR-25-STATIC-POST-6.jpg';
import FlashSaleJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/flash-sale.jpeg';
import PS5Slide2JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/PS5-slide-2.jpg';
import BC9FBAd1JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/BC9-FB-Ad-1.jpg';
import RCDLab4JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/RCD-Lab-4.jpg';
import Purz140FBAd2JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/Purz-140-FB-ad-2.jpg';
import BaseballCapsAds1JPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/Baseball-Caps-ads1.jpg';
import LabelDesignSocialJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/label-design.jpg';
import Purz140FBAdJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/Purz-140-FB-ad.jpg';
import SodiumFamilyJPG from '../components/assets/img/project/Mudd-all-Portfolio/Social-Media/sodium-family.jpeg';

// Website Design Imports
import CrownChronoBandsPDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/crown-chrono-bands.pdf';
import CrownChronoBandsIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/CrownChronoBandsIMG.png';
import HomeStartupPDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Home-Startup.pdf';
import HomeStartupIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/HomeStartupIMG.png';
import HomeBuildItUpdatePDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Home-build-it-update.pdf';
import HomeBuildItUpdateIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/HomeBuildItUpdateIMG.png';
import NootropicsHomePDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Nootropics-Home.pdf';
import NootropicsHomeIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/NootropicsHomeIMG.png';
import ArchiesPDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Archies.pdf';
import ArchiesIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/ArchiesIMG.png';
import TimeClockHeroHomeJPG from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/TimeClock-Hero-Home.jpg';
import HomeNexusNewUpdatePDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Home-Nexus-New-update.pdf';
import HomeNexusNewUpdateIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/HomeNexusNewUpdateIMG.png';
import HomeEcoPavingPDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Home-EcoPaving.pdf';
import HomeEcoPavingIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/HomeEcoPavingIMG.png';
import OptimoPeptidesHomePDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/OptimoPeptides-Home-Page.pdf';
import OptimoPeptidesHomeIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/OptimoPeptidesHomeIMG.png';
import OptimoPeptidesProductPDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/OptimoPeptides-product-Page.pdf';
import OptimoPeptidesProductIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/OptimoPeptidesProductIMG.png';
import PropertyManagementPDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Property-Management.pdf';
import PropertyManagementIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/PropertyManagementIMG.png';
import AndreasWeddingPDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Andreas-Wedding.pdf';
import AndreasWeddingIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/AndreasWeddingIMG.png';
import ClearChoiceHomePDF from '../components/assets/img/project/Mudd-all-Portfolio/Website-Designs/Clear-choice-home.pdf';
import ClearChoiceHomeIMG from '../components/assets/img/project/Mudd-all-Portfolio/Label-Designs/ClearChoiceHomeIMG.png';

export let info = {
  firstName: "Muddassir",
  lastName: "Hassan",
  position: "Frontend UX/UI Designer and Full Stack Developer",
  portfoliohead: "It’s all about my Passion",
  selfPortrait: mudd,
  miniBio: [
    {
      text: "become energetic with RC Cars",
    },

    {
      text: "free no - yes I am a freelancer",
    },
    {
      text: "me@genxsmedia.com",
    },
  ],
  socials: [
    {
      link: "https://facebook.com",
      icon: "fa fa-facebook",
      label: "facebook",
    },
    {
      link: "https://instagram.com",
      icon: "fa fa-instagram",
      label: "instagram",
    },
    {
      link: "https://github.com",
      icon: "fa fa-github",
      label: "github",
    },
    {
      link: "https://linkedin.com",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },
    {
      link: "https://twitter.com",
      icon: "fa fa-twitter",
      label: "twitter",
    },
  ],
  bio: "Hi guys ! This is MUDD here as my friends call me. On papers though the world knows me as Muddassir. Who am I? To put it short, the answer to your questions, the solution to your problems, the way out for your business miseries. The graphic designer and front-end developer who has delivered nothing short of the very best to his hundreds of satisfied clients the world over since my companys inception in 2006. Looking forward for not a business collaboration but a life long friendship as I don’t make clients. I just make friends.",
  skills: {
    proficientWith: [
      "html5",
      "CSS3",
      "git",
      "github",
      "bootstrap",
      "react",
      "figma",
      "xd",
    ],
    exposedTo: ["adobe photoshop", "adobe illustrator"],
  },
  portfolio: [
    {
      title: "LAZY5VETS",
      live: "https://lazy5vets.com/",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
    {
      title: "KETTLE CORN NYC",
      live: "https://www.kettlecornnyc.com/",
      image: "https://genxsmedia.com/wp-content/uploads/2019/11/kettlecorn.jpg",
    },
    {
      title: "LEPTOURGOS BABY",
      live: "http://babyleptourgos.com/",
      image: "https://genxsmedia.com/wp-content/uploads/2019/11/baby.jpg",
    },
    {
      title: "WELCH'S GIG",
      live: "http://welchsgig.com/",
      image: "https://genxsmedia.com/wp-content/uploads/2019/11/Layer-8.png",
    },
  ],
  services: [
    {
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
      title: "Design",
      speciality: [
        "India",
        "Australia",
        "England",
        "South Africa",
        "West Indies",
        "Newzealand",
      ],
    },
    {
      title: "Project 2",
      live: "https://paytonpierce.dev",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
    {
      title: "Project 3",
      live: "https://paytonpierce.dev",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
    {
      title: "Project 4",
      live: "https://paytonpierce.dev",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
    {
      title: "Project 5",
      live: "https://paytonpierce.dev",
      image:
        "https://genxsmedia.com/wp-content/uploads/2019/02/lazy5vets-1.jpg",
    },
  ],
  projects: [
    [
      {
        id: 1,
        title: "BuyBack X",
        image: proje4,
        description: "NextJS, MangoDB",
        link: "https://buybackxstores.com/",
      },
      {
        id: 2,
        title: "Celler Certified",
        image: proje6,
        description: "ReactJS, MangoDB",
        link: "https://www.cellercertified.com/",
      },
      {
        id: 2,
        title: "Celler Certifieds",
        image: proje6,
        description: "ReactJS, MangoDB",
        link: "https://www.cellercertified.com/",
      },
    ],
    [
        {
          id: 1,
          title: "LAZY5VETS",
          image: proje7,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
        {
          id: 2,
          title: "cfgdrfgerg",
          image: proje8,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
      ],
      [
        {
          id: 1,
          title: "LAZY5VETS",
          image: proje0,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
        {
          id: 2,
          title: "cfgdrfgerg",
          image: innerTwoProject03,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
      ],
      [
        {
          id: 1,
          title: "LAZY5VETS",
          image: proje1,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
        {
          id: 2,
          title: "cfgdrfgerg",
          image: innerTwoProject03,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
      ],
      [
        {
          id: 1,
          title: "LAZY5VETS",
          image: proje2,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://lazy5vets.com/",
        },
        {
          id: 2,
          title: "cfgdrfgerg",
          image: innerTwoProject03,
          description: "Explore cutting-edge motion graphics design.",
          link: "https://www.lazy5vets.com/",
        },
      ],
  ],
  works:[
    {
      "name": "Cellular Optics",
      "description": "Diagonastic Testing Software for Used Devices",
      "image": cellularIMG,
      "link": "https://cellularoptics.com/",
      "category": "Web Development",
      "technology": "React, Node.JS, MangoDB",
      "year": "2022"
  },
  {
      "name": "Celler Certified",
      "description": "Buy or Sell Used Devices With Confidence",
      "image": cellercertifiedIMG,
      "link": "https://www.cellercertified.com/",
      "category": "Web Development",
      "technology": "React, Node.JS, MangoDB",
      "year": "2022"
  },
  {
    "name": "SKU Optics",
    "description": "E-commerce Inventory Software Solution",
    "image":skuopticsdIMG,
    "link": "https://www.skuoptics.com/",
    "category": "Web Development",
    "technology": "NextJS, Node.JS, Express",
    "year": "2022"
},
{
  "name": "AS Design",
  "description": "Home Remodeling Solutions Provider in Long Island",
  "image":ASdesignIMG ,
  "link": "https://asdesignli.com/",
  "category": "Web Development",
  "technology": "WordPress, Divi Theme, Custom Design",
  "year": "2023"
},
{
  "name": "Recommerced",
  "description": "Solutions to repurpose their IT Assets",
  "image": recommercedIMG,
  "link": "https://www.skuoptics.com/",
  "category": "Web Development",
  "technology": "NextJS, Node.JS, Express",
  "year": "2023"
},
{
  "name": "Outset Ventures",
  "description": "Venture capital fund and technology incubator supporting deep-tech startups.",
  "image": outsetIMG,
  "link": "https://outset.ventures/",
  "category": "Web Development",
  "technology": "WordPress, Divi, Custom UX Design",
  "year": "2023"
},
{
  "name": "Crown Chrono: Luxury Watch Bands",
  "description": "E-commerce platform for bespoke luxury watch accessories and straps.",
  "image": chronoIMG,
  "link": "https://www.crownchronobands.com/",
  "category": "Web Development",
  "technology": "WordPress, Divi, Custom UX Design",
  "year": "2022"
},
{
  "name": "Nexus Performance Centre",
  "description": "Elite fitness and athletic performance training facility based in Ottawa.",
  "image": nexusperformanceIMG,
  "link": "http://www.nexusperformancecentre.ca/",
  "category": "Web Development",
  "technology": "WordPress, Divi, Custom UX Design",
  "year": "2022"
},
  {
    "name": "SARMs Support Guide",
    "description": "Selective Androgen Receptor Modulators (SARMs) and support compounds in scientific research.",
    "image": SARMSEBOOK5IMG,
    "iframeLink": SARMSEBOOK5,
    "category": "Ebook Design",
    "technology": "Indesign, Photoshop, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "SARMs Uncovered",
    "description": "An exploration of Selective Androgen Receptor Modulators, their mechanisms, and tissue-specific targeting in anabolic research.",
    "image": SARMsUncovered,
    "iframeLink": SARMsUncoveredPdf,
    "category": "Ebook Design",
    "technology": "Indesign, Photoshop, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Investigating Research Peptides",
    "description": "A scientific perspective on peptide activity in physiological systems, focusing on tissue repair, metabolism, and neurological research.",
    "image": InvestifagePeptide,
    "iframeLink": InvestifagePeptidePdf,
    "category": "Ebook Design",
    "technology": "Indesign, Photoshop, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Vitamins & Vitality",
    "description": "A guide to essential micronutrients, addressing common deficiencies and integrating targeted supplements with hormone replacement therapy.",
    "image": Vitamins,
    "iframeLink": VitaminsPdf,
    "category": "Ebook Design",
    "technology": "Indesign, Photoshop, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "L-Evate Peptide Playbook",
    "description": "Focuses on unlocking healthspan through recovery, performance, and longevity peptides to stimulate natural cellular repair.",
    "image": PeptideEvate,
    "iframeLink": PeptideEvatePdf,
    "category": "Ebook Design",
    "technology": "Indesign, Photoshop, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Recovery Supplements Guide",
    "description": "The ultimate guide to faster healing and peak performance through amino acids, adaptogens, and metabolic support compounds.",
    "image": RecoverySupplements,
    "iframeLink": RecoverySupplementsPdf,
    "category": "Ebook Design",
    "technology": "Indesign, Photoshop, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Testosterone Health Playbook",
    "description": "An essential guide to optimizing testosterone through movement, nutrition, and recovery to enhance energy, confidence, and performance.",
    "image": Testosterone,
    "iframeLink": TestosteronePdf,
    "category": "Ebook Design",
    "technology": "Indesign, Photoshop, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Optimo Peptide Playbook",
    "description": "Protocols for optimal health and regeneration, exploring how peptides act as messengers to enhance recovery, sleep, and vitality.",
    "image": Peptide,
    "iframeLink": PeptidePdf,
    "category": "Ebook Design",
    "technology": "Indesign, Photoshop, Ai (Gemini - Lab flow - Envato Ai)"
  },
   {
    "name": "Orion Peptides: Story-Based Campaign",
    "description": "Marketing email for Orion Peptides focusing on quality, 99%+ purity, and third-party testing for research-grade products.",
    "image": Email2StoryBased,
    "iframeLink": Email2StoryBased,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Blend-Focused Newsletter",
    "description": "Newsletter detailing the benefits of peptide blends, specifically CJC-1295 No DAC and Ipamorelin, for consistent GH signaling research.",
    "image": BHNewsletterEmail12BBlend,
    "iframeLink": BHNewsletterEmail12BBlend,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: GH Signaling Education",
    "description": "Educational email on the coordinated GH release signaling achieved by pairing Sermorelin and Ipamorelin in research models.",
    "image": BHNewsletterWeek4Email3Blend,
    "iframeLink": BHNewsletterWeek4Email3Blend,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Peptide Mechanism Guide",
    "description": "Educational content highlighting different peptide mechanisms including BPC-157 for repair, TB-500 for cellular remodeling, and GHRP-6 for hormonal signaling.",
    "image": BHNewsletterMarchEmail1Educational,
    "iframeLink": BHNewsletterMarchEmail1Educational,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Orion Peptides: Welcome Series",
    "description": "Welcome email for Orion Peptides introducing their high purity standards, third-party testing, and initial discount offers for researchers.",
    "image": OrionWelcomeEmail1,
    "iframeLink": OrionWelcomeEmail1,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Precision Metabolism Campaign",
    "description": "Highlights targeted peptides like Adipotide and GLP-1 Liraglutide for precision in metabolic and body composition research.",
    "image": BHNewsletterEmail11BBenefit,
    "iframeLink": BHNewsletterEmail11BBenefit,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Dynamic Duo Newsletter",
    "description": "Focuses on the 'Dynamic Duo' of CJC-1295 No DAC and Ipamorelin for controlled, long-term growth hormone modulation.",
    "image": BHNewsletterMarchEmail3BBlend,
    "iframeLink": BHNewsletterMarchEmail3BBlend,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Peptide Synergy Campaign",
    "description": "Promotes structured research designs using combinations like BPC-157 + TB-500 and CJC-1295 + Ipamorelin.",
    "image": BHNewsletterEmail5Compounds,
    "iframeLink": BHNewsletterEmail5Compounds,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Valentine's Rewards Campaign",
    "description": "Promotional email for a Valentine's Day sale featuring tiered rewards and exclusive amino, protein, and greenz bundles.",
    "image": BHNewsletterEmail1Valentine,
    "iframeLink": BHNewsletterEmail1Valentine,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Long-Term Impact Systems",
    "description": "Discusses peptide synergy and simple systems for long-term impact using dual-pathway blends like CJC-1295 No DAC + Ipamorelin.",
    "image": BHNewsletterEmail12Blend,
    "iframeLink": BHNewsletterEmail12Blend,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Inventory Alert Campaign",
    "description": "Urgency-based promotional email highlighting fast-moving inventory during the Valentine's Day sale event.",
    "image": BHNewsletterEmail4Stock,
    "iframeLink": BHNewsletterEmail4Stock,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Community Favorite Blends",
    "description": "Showcases community favorite compounds like NAD+, BPC-157, and Tesamorelin paired with Valentine's research rewards.",
    "image": BHNewsletterFebWeek1Email3Blend,
    "iframeLink": BHNewsletterFebWeek1Email3Blend,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Synchronized Release Signaling",
    "description": "Detailed look at coordinated peptide signaling using CJC-1295 No DAC and Ipamorelin for synchronized growth hormone release.",
    "image": BHNewsletterMarchEmail3Blend,
    "iframeLink": BHNewsletterMarchEmail3Blend,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Recovery Pathway Series",
    "description": "Explores the relationship between sleep-associated signaling pathways and recovery, featuring DSIP and MK-677.",
    "image": BHNewsletterWannaSayGoodnight,
    "iframeLink": BHNewsletterWannaSayGoodnight,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Precision Body Composition",
    "description": "Focuses on precision in body composition research using compounds like Adipotide, Semaglutide, and Retatrutide.",
    "image": BHNewsletterAprilEmail2,
    "iframeLink": BHNewsletterAprilEmail2,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Targeted Nasal Delivery",
    "description": "Discusses the benefits of nasal delivery in peptide research, focusing on Tesamorelin for metabolic study models.",
    "image": BHNewsletterWeek4Email2Benefit,
    "iframeLink": BHNewsletterWeek4Email2Benefit,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: St. Patrick's Final Call",
    "description": "Final reminder for the St. Patrick's Day sale offering 17% off sitewide on peptide vials, blends, and nasal formats.",
    "image": BHNewsletterEmail3March19,
    "iframeLink": BHNewsletterEmail3March19,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Brand Quality Standards",
    "description": "Brand-focused email explaining the deliberate evaluation and quality standards for adding products to the research catalog.",
    "image": BHNewsletterMarchEmail2BStoryBrand,
    "iframeLink": BHNewsletterMarchEmail2BStoryBrand,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Intranasal Absorption Study",
    "description": "Educational content on intranasal peptide delivery for studying absorption and targeted pathway interaction.",
    "image": BHNewsletterWeek2Email4Educational,
    "iframeLink": BHNewsletterWeek2Email4Educational,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: St. Patrick's Launch",
    "description": "Announcement of the 3-day St. Patrick's Day pricing event featuring 17% off the full research catalog.",
    "image": BHNewsletterEmail1March17,
    "iframeLink": BHNewsletterEmail1March17,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Premium Shaker Promotion",
    "description": "Promotional email offering a free exclusive shaker for all orders over $50 while supplies last.",
    "image": BHNewsletterFreeShaker,
    "iframeLink": BHNewsletterFreeShaker,
    "category": "Email Design",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
{
    "name": "BC9: Custom Peptide Packaging",
    "description": "Packaging design for BC9 peptide boxes measuring 150x70x36mm, labeled for lab research only with 99% purity.",
    "image": PeptideBoxIMG,
    "iframeLink": PeptideBoxPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "BC9: Small Vial Box Series",
    "description": "Small vial packaging for BC9 research chemicals, dimensions 20x20x44mm, marked for laboratory research use only.",
    "image": SmallVialBoxIMG,
    "iframeLink": SmallVialBoxPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Premium Skin Care Label Design",
    "description": "A document identified as skin care related content.",
    "image": FacialCreamIMG,
    "iframeLink": FacialCreamPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Optimo Peptides: Sermorelin Label",
    "description": "Label for 10mg Sermorelin peptide from Optimo Peptides, featuring 99% purity and an expiration date of Apr 26, 2028.",
    "image": SermorelinIMG,
    "iframeLink": SermorelinPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Purz: B7-33 Research Label",
    "description": "Research label for 12mg B7-33 peptide with 99% purity, manufactured in the USA with an expiration date of Jun 18, 2028.",
    "image": B733IMG,
    "iframeLink": B733PDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "BC9: Bacteriostatic Water Branding",
    "description": "Label for 30ml Bacteriostatic Water for laboratory research, best before May 27, 2027.",
    "image": BACWaterIMG,
    "iframeLink": BACWaterPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Nootropics Unlimited: Product Revamp",
    "description": "Product revamp image for Nootropics Unlimited showcasing Fasoracetam powder and liquid formats for research use.",
    "image": AllThreeNewJPG,
    "iframeLink": AllThreeNewJPG,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "RCD Bio: MOTS-C Nasal Spray",
    "description": "Nasal spray label for 200mcg MOTS-C (10ml) manufactured by RCD Bio, expiring Mar 12, 2027.",
    "image": MOTSCNasalJPG,
    "iframeLink": MOTSCNasalJPG,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Purz: Emideltide Purity Label",
    "description": "Lab research label for 2mg Emideltide with 99% purity, USA made, expiring Feb 17, 2028.",
    "image": EmideltideIMG,
    "iframeLink": EmideltidePDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Iron Mountain Labz: Support Capsules",
    "description": "Supplement facts and label for 60 capsules of advanced testicular and prostate support, best before Jan 01, 2027.",
    "image": AdvancedSupportIMG,
    "iframeLink": AdvancedSupportPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "RCD Bio: KPV Nasal Spray Material",
    "description": "RCD Bio research material label for 500mcg KPV nasal spray (10ml), expiring Mar 12, 2027.",
    "image": KPVNasalIMG,
    "iframeLink": KPVNasalPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Optimo Peptides: TB-500 Label",
    "description": "Optimo Peptides label for 10mg TB-500 intended exclusively for laboratory research purposes.",
    "image": TB500IMG,
    "iframeLink": TB500PDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Nootropics Unlimited: 7-OH Shots",
    "description": "Label for 30mg total 7-Hydroxy Mitragynine (60ml bottle) featuring 2 shots per bottle, expiring Jan 09, 2027.",
    "image": HydroxyShotsJPG,
    "iframeLink": HydroxyShotsPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "RCD Bio: Melanotan-2 Nasal Spray",
    "description": "RCD Bio research label for 100mcg Melanotan-2 nasal spray (10ml), expiring Feb 17, 2027.",
    "image": Melanotan2IMG,
    "iframeLink": Melanotan2PDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Iron Mountain Labz: Enclomiphene Citrate",
    "description": "Iron Mountain Labz label for 20mg Enclomiphene Citrate (54 tabs), best before Jan 25, 2027.",
    "image": EnclomipheneIMG,
    "iframeLink": EnclomiphenePDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Premium Lab-Grade: GLP-1.3 Branding",
    "description": "Research-grade 1mg GLP-1.3 (Liraglutide) label with 99% purity, expiring Dec 05, 2028.",
    "image": GLP1IMG,
    "iframeLink": GLP1PDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Nootropics Unlimited: Capsule Branding",
    "description": "USA-made 5a-Hydroxy Laxogenin capsule labels (50mg, 60ct) for Nootropics Unlimited.",
    "image": CapsulesLabelsIMG,
    "iframeLink": CapsulesLabelsPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Orion Peptides: IGF-1 LR3 Label",
    "description": "Orion Peptide label for 1mg IGF-1 LR3 with 99% purity for research only.",
    "image": IGF1LR3IMG,
    "iframeLink": IGF1LR3PDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "RCD Bio: Epithalon Nasal Spray",
    "description": "RCD Bio research label for 1mg Epithalon nasal spray (10ml), expiring Feb 14, 2027.",
    "image": EpithalonIMG,
    "iframeLink": EpithalonPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Research-Grade: OT-9 Amino Label",
    "description": "Research label for 2mg OT-9 amino with 99% purity, USA made, expiring Nov 16, 2028.",
    "image": OT9AminoIMG,
    "iframeLink": OT9AminoPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  // {
  //   "name": "RCD Bio: 7OH Shots Branding",
  //   "description": "Detailed label for 7OH Shots (30mg total) by RCD Bio, manufactured for research use and expiring Jan 09, 2027.",
  //   "image": HydroxyShotsPDF,
  //   "iframeLink": HydroxyShotsPDF,
  //   "category": "Label Design",
  //   "technology": "Adobe Illustrator"
  // },
  {
    "name": "RCD Bio: 7-OH Kratom Tablets",
    "description": "RCD Bio label for 25mg 7-OH Kratom (6 tabs, 150mg total) with Mint Chocolate flavor, expiring Mar 01, 2027.",
    "image": HydroxyTabsJPG,
    "iframeLink": HydroxyTabsJPG,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Iron Mountain Labz: Bromantane Liquid",
    "description": "Iron Mountain Labz Bromantane liquid (100mg per ML, 60ml total) research material.",
    "image": BromantaneIMG,
    "iframeLink": BromantanePDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Iron Mountain Labz: Sleep Enhancement",
    "description": "Sleep enhancement label for 60 CBD (25mg) + Melatonin gummies, best before Jan 01, 2027.",
    "image": CBDMelatoninIMG,
    "iframeLink": CBDMelatoninPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Nootropics Unlimited: 7-OH Tablets",
    "description": "Label details for 25mg 7-OH Kratom tablets (6 count) by Nootropics Unlimited, expiring Mar 16, 2027.",
    "image": HydroxyTabsIMG,
    "iframeLink": HydroxyTabsPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Iron Mountain Labz: Dream Catcher",
    "description": "Supplement facts for Dream Catcher sleep aid (30 servings), featuring GABA, Valerian Root, and Melatonin, best before Jan 01, 2027.",
    "image": DreamCatcherJPG,
    "iframeLink": DreamCatcherPDF,
    "category": "Label Design",
    "technology": "Adobe Illustrator"
  },
  {
    "name": "Instabins: Brand Marketing Graphic",
    "description": "Marketing graphic for Instabins, a one-stop shop for trash disposal requirements.",
    "image": Insta2JPG,
    "iframeLink": Insta2JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Lab Documentation Post",
    "description": "Educational post emphasizing that documentation is key for reproducible research outcomes.",
    "image": Mar28Static7JPG,
    "iframeLink": Mar28Static7JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Peptide Purity Awareness",
    "description": "Social media post for Behemoth Labz stating that peptide purity matters for accurate experimental results.",
    "image": Mar9Static2JPG,
    "iframeLink": Mar9Static2JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: Structured Product Highlight",
    "description": "Product highlight for PureRawz showcasing structured packaging and clear identification for documented workflows.",
    "image": Mar27ProductJPG,
    "iframeLink": Mar27ProductJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Research Ethics: Stability Tip Graphic",
    "description": "Stability tip post advising researchers to avoid heat or light exposure to maintain research-grade integrity.",
    "image": Mar31Static8JPG,
    "iframeLink": Mar31Static8JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Lab Safety: Equipment Guide Post",
    "description": "Lab safety post promoting the use of proper protective gear and maintaining an organized workspace.",
    "image": Mar3StaticJPG,
    "iframeLink": Mar3StaticJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Refresh",
    "description": "Post encouraging lab reorganization to boost focus and efficiency for peak productivity.",
    "image": AprilPost2JPG,
    "iframeLink": AprilPost2JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "BuyBack: Fast Cash Quote Graphic",
    "description": "Promotional graphic for BuyBack for selling electronics for fast and easy cash.",
    "image": QuickQuoteJPG,
    "iframeLink": QuickQuoteJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "STATIC POST",
    "description": "March research highlights featuring batch information and expiry dates for PureRawz materials.",
    "image": Mar31StaticJPG,
    "iframeLink": Mar31StaticJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Volk Audio: Alpine Control Interface",
    "description": "Advertisement for Volk Audio Custom 6 Systems showing a digital interface with Alpine audio controls.",
    "image": Volk1JPG,
    "iframeLink": Volk1JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "STATIC POST",
    "description": "Integrity focus post highlighting sealed, secure packaging designed to maintain stability during transport.",
    "image": Feb18Static8JPG,
    "iframeLink": Feb18Static8JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Nootropics Unlimited: Hydrazide Highlight",
    "description": "Graphic for Nootropics Unlimited featuring products like Phenylpiracetam Hydrazide for research use.",
    "image": YouAreYourOwnJPG,
    "iframeLink": YouAreYourOwnJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Research Quality: Lab Testing Graphic",
    "description": "Quality assurance post stating that lab-tested, traceable peptides ensure reliable experimental results.",
    "image": Mar21Static5JPG,
    "iframeLink": Mar21Static5JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: Brand Awareness Campaign",
    "description": "Brand awareness post for PureRawz highlighting research-grade quality and carefully sourced ingredients.",
    "image": PurzBrandAwarenessJPG,
    "iframeLink": PurzBrandAwarenessJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: UX/UI Design Showcase",
    "description": "Expert UX/UI design services showcase featuring a mockup of the Behemoth Labz website.",
    "image": UxUiJPG,
    "iframeLink": UxUiJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PRODUCT POST",
    "description": "Product presentation post showing organized formats and clear identification for PureRawz lab-ready materials.",
    "image": Mar21ProductJPG,
    "iframeLink": Mar21ProductJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Orion Peptides: Welcome Discount Campaign",
    "description": "Welcome post for Orion Peptides offering 10% off for research-grade compounds like BPC-157.",
    "image": Post2JPG,
    "iframeLink": Post2JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Structured Lab Materials",
    "description": "Graphic highlighting precision-built, structured lab materials designed for organized workflows.",
    "image": AprilPost1JPG,
    "iframeLink": AprilPost1JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: Premium Sales Conversion",
    "description": "Conversion-focused post for PureRawz premium research compounds with secure checkout and high-purity chemicals.",
    "image": PurzConversionJPG,
    "iframeLink": PurzConversionJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: St. Patrick's 17% Off Event",
    "description": "St. Patrick's Day sale post offering 17% off sitewide on peptides, wellness compounds, and stacks.",
    "image": Mar14StaticJPG,
    "iframeLink": Mar14StaticJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: Sale Final Call Event",
    "description": "Last chance notification for the St. Patrick's Day 17% off sitewide offer ending tonight.",
    "image": Mar19FinalCallJPG,
    "iframeLink": Mar19FinalCallJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: St. Patrick's Main Event",
    "description": "St. Patrick's Day main event post for PureRawz featuring 17% off for lab upgrades.",
    "image": Mar17MainDayJPG,
    "iframeLink": Mar17MainDayJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "FINAL CALL STATIC POST",
    "description": "Final day alert for the St. Patrick's Day sale with 17% off using code GREEN17OFF.",
    "image": Mar19FinalCallStaticJPG,
    "iframeLink": Mar19FinalCallStaticJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Behemoth Labz: Trusted Lab Partner",
    "description": "Trusted lab partner post for Behemoth Labz featuring USA-made, HPLC-tested research materials.",
    "image": Mar4Static1JPG,
    "iframeLink": Mar4Static1JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Prometheuz HRT: Private Consultation Ad",
    "description": "Promotional graphic for Prometheuz HRT confidential men's health consultations.",
    "image": Post3PromeoJPG,
    "iframeLink": Post3PromeoJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Prometheuz HRT: Personalized Support Ad",
    "description": "Personalized wellness support ad for Prometheuz HRT featuring one-on-one care and doctor-guided plans.",
    "image": Post2PromeoJPG,
    "iframeLink": Post2PromeoJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PRODUCT POST",
    "description": "Product detail post highlighting clear labeling and batch identification for research materials.",
    "image": Mar9ProductJPG,
    "iframeLink": Mar9ProductJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Prometheuz HRT: Weight Management Program",
    "description": "Doctor-supervised weight management program ad for Prometheuz HRT.",
    "image": Post1PromeoJPG,
    "iframeLink": Post1PromeoJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Prometheuz HRT: Clinical Care Graphic",
    "description": "Private men's wellness support graphic for Prometheuz HRT with personalized clinical care.",
    "image": Post4PromeoJPG,
    "iframeLink": Post4PromeoJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "STATIC POST",
    "description": "Lab-grade peptide post focusing on accurate formulation and batch-verified studies.",
    "image": Mar25Static6JPG,
    "iframeLink": Mar25Static6JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Nootropics Unlimited: Cyber Steals Flash Sale",
    "description": "Cyber Steals flash sale for Nootropics Unlimited with discounts up to 20% off based on order value.",
    "image": FlashSaleJPG,
    "iframeLink": FlashSaleJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "BuyBack: PS5 Pro Upgrade Campaign",
    "description": "Upgrade offer for BuyBack allowing users to trade a base PS5 for up to $400 towards a PS5 Pro.",
    "image": PS5Slide2JPG,
    "iframeLink": PS5Slide2JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "BC9: FB Sublingual Tablet Ad",
    "description": "Facebook ad for high-quality sublingual tablets with 10% off code BC10.",
    "image": BC9FBAd1JPG,
    "iframeLink": BC9FBAd1JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "RCD Bio: NAD+ Cognitive Energy Ad",
    "description": "NAD+ research material ad for enhanced cellular energy and cognitive function with a 10% discount.",
    "image": RCDLab4JPG,
    "iframeLink": RCDLab4JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: Edge-X 140 Endurance Ad",
    "description": "Ad for Edge-X 140 focusing on endurance and lean muscle mass with 15% off using code PRZ15.",
    "image": Purz140FBAd2JPG,
    "iframeLink": Purz140FBAd2JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: Branded Apparel Ad",
    "description": "Promotional post for PureRawz branded baseball caps with a 15% site-wide discount.",
    "image": BaseballCapsAds1JPG,
    "iframeLink": BaseballCapsAds1JPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "POST",
    "description": "Showcase of eye-catching label designs for nootropics research compounds like Caffeine Anhydrous.",
    "image": LabelDesignSocialJPG,
    "iframeLink": LabelDesignSocialJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "PureRawz: Ultra Lean Series Ad",
    "description": "Ultra Lean Series ad for muscle gain and cognitive clarity with 15% off for research-only use.",
    "image": Purz140FBAdJPG,
    "iframeLink": Purz140FBAdJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
  {
    "name": "Nootropics Online: Tianeptine Product Family",
    "description": "Product family display for Nootropics Online featuring Tianeptine Sodium in powder and liquid forms.",
    "image": SodiumFamilyJPG,
    "iframeLink": SodiumFamilyJPG,
    "category": "Social Media",
    "technology": "Figma, Ai (Gemini - Lab flow - Envato Ai)"
  },
{
    "name": "Crown Chrono: Rolex Strap Collection",
    "description": "Custom strap designs for Rolex watches, featuring styles for the Submariner Date and details on strap technology.",
    "image": CrownChronoBandsIMG,
    "iframeLink": CrownChronoBandsPDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Startup Ideas Pakistan: Innovation Hub",
    "description": "Landing page design for Startup Ideas Pakistan, a platform for early adopters and innovation seekers to find imaginative tech.",
    "image": HomeStartupIMG,
    "iframeLink": HomeStartupPDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Build It Back: Contractor Portal",
    "description": "Website layout for Build It Back, a trusted renovation contractor in Ottawa specializing in kitchen, basement, and bathroom remodeling.",
    "image": HomeBuildItUpdateIMG,
    "iframeLink": HomeBuildItUpdatePDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Nootropics Unlimited: eCommerce Portal",
    "description": "E-commerce home page design for Nootropics Unlimited, focused on research in cognitive, metabolic, and longevity science.",
    "image": NootropicsHomeIMG,
    "iframeLink": NootropicsHomePDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Arches Counselling: Family Support Site",
    "description": "Website design for Arches Counselling, committed to providing inclusive spaces and ethical curiosity for families.",
    "image": ArchiesIMG,
    "iframeLink": ArchiesPDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Time Clock Hero: Enterprise SaaS Design",
    "description": "Hero section design for Time Clock Hero, a simplified time tracking and payroll integration app for small businesses.",
    "image": TimeClockHeroHomeJPG,
    "iframeLink": TimeClockHeroHomeJPG,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Nexus Performance: Elite Fitness Portal",
    "description": "Gym and fitness website design for Nexus Performance Center, offering personal training, virtual bootcamps, and dry cupping.",
    "image": HomeNexusNewUpdateIMG,
    "iframeLink": HomeNexusNewUpdatePDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Eco Paving: Advanced Service Landing Page",
    "description": "Service-oriented website design for Eco Paving Advanced Services, Ottawa’s top-rated paving and interlock company.",
    "image": HomeEcoPavingIMG,
    "iframeLink": HomeEcoPavingPDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Andreas Wedding: Bespoke RSVP Portal",
    "description": "Wedding event landing page for Andreas and Agatha's marriage in Athens, Greece, including RSVP and travel details.",
    "image": AndreasWeddingIMG,
    "iframeLink": AndreasWeddingPDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Clear Choice: Auto Glass Service Site",
    "description": "Vehicle glass shop website design for Clear Choice Auto Glass, offering mobile windshield replacement and repair services in Ottawa.",
    "image": ClearChoiceHomeIMG,
    "iframeLink": ClearChoiceHomePDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Optimo Peptides: High-Purity Home Page",
    "description": "Home page layout for Optimo Peptides, providing premium research-grade peptides with 3rd-party verified COAs.",
    "image": OptimoPeptidesHomeIMG,
    "iframeLink": OptimoPeptidesHomePDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Protagonist: NYC Property Management",
    "description": "Website design for Protagonist Property Management, specializing in NYC real estate markets with secure portal access for owners and tenants.",
    "image": PropertyManagementIMG,
    "iframeLink": PropertyManagementPDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  {
    "name": "Optimo Peptides: Detailed Product Portal",
    "description": "Product detail page design for GHK-CU Copper Peptide, including chemical formulas, working mechanisms, and lab safety notices.",
    "image": OptimoPeptidesProductIMG,
    "iframeLink": OptimoPeptidesProductPDF,
    "category": "Website Designs",
    "technology": "Figma"
  },
  ],
  testimonials :[
    {
      quote: "Skilled web developer! Strong communication skills and fast delivery. I'll certainly be repeating business with them!",
      author: "Charles K",
      title: "CEO Quaint Energy",
      avatar: testimonialAvatar1
    },
    {
      quote: "They did a great job building our new website, we are very happy and it looks great. The price was great also.",
      author: "Tyson Bellamy",
      title: "CEO T Y",
      avatar: testimonialAvatar2
    },
    {
      quote: "Muhammad is a good guy. Does really excellent work and will definitely use again. He worked on some flash (not easy) and HTML elements. Very pro look.",
      author: "Phillip Colin",
      title: "P C",
      avatar: testimonialAvatar3
    },
    {
      quote: "Great web developer! Great communication and very quick! Definetly will do business again.",
      author: "Whilly Bermudez",
      title: "CEO. Whilly Bermudez",
      avatar: testimonialAvatar2
    },
    {
      quote: "Excellent vendor who works hard to complete the project on time and on budget. No complaints at all and would use again in the future.",
      author: "Dan G.",
      title: "DG45",
      avatar: testimonialAvatar3
    }
  ]
};
